import { createApp } from 'vue';
import { registerPlugins } from '@src/app/plugins';
import { api } from '@src/shared/api';
import { initWeb3 } from '@src/shared/lib/web3/config';
import '@src/shared/styles/global.css';
import app from './App.vue';

// Сети кошелька строятся из ответа бэка — wagmi-конфиг должен существовать
// до установки плагинов, поэтому старт ждёт listChains.
try {
	// TODO andrew jackson refactor
	const { chains } = await api.listChains();
	initWeb3(chains);

	const root = createApp(app);

	registerPlugins(root);
	root.mount('#app');
} catch (error) {
	document.querySelector('#app')?.replaceChildren('Failed to load app configuration. Please try again later.');
	// eslint-disable-next-line no-console
	console.error('bootstrap failed', error);
}
